<template>
   <div class="relative">
      <div class="flex-1 mt-1 bg-gray-100 px-4 pt-5 items-center">
        <div class="bg-white w-fullrounded-lg shadow form-payement"> 
            
            <div class="">
                <div class="bg-white rounded-lg px-6 mb-20">
                        <!--payments by seller-->
                        <div  class="intro-y block sm:flex items-center pt-5">
                          <h2 class="text-lg font-medium truncate mr-5 flex text-blue-500 flex-no-wrap items-center">
                            <svg class="fill-current mr-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.667 14c1.781 0 3.333-.671 3.333-1.5s-1.552-1.5-3.333-1.5c-1.781 0-3.333.671-3.333 1.5s1.551 1.5 3.333 1.5zm.062-1.34c-.199-.06-.81-.111-.81-.45 0-.189.223-.358.639-.396v-.148h.214v.141c.156.004.33.021.523.06l-.078.229c-.147-.034-.311-.066-.472-.066l-.048.001c-.321.013-.347.191-.125.267.364.112.844.195.844.493 0 .238-.289.366-.645.397v.146h-.214v-.139c-.22-.002-.451-.038-.642-.102l.098-.229c.163.042.367.084.552.084l.139-.01c.247-.034.296-.199.025-.278zm-.062 5.34c1.261 0 2.57-.323 3.333-.934v.434c0 .829-1.552 1.5-3.333 1.5-1.781 0-3.333-.671-3.333-1.5v-.434c.763.611 2.071.934 3.333.934zm0-3.333c1.261 0 2.57-.323 3.333-.934v.434c0 .829-1.552 1.5-3.333 1.5-1.781 0-3.333-.671-3.333-1.5v-.434c.763.611 2.071.934 3.333.934zm0 1.666c1.261 0 2.57-.323 3.333-.935v.435c0 .828-1.552 1.5-3.333 1.5-1.781 0-3.333-.672-3.333-1.5v-.435c.763.612 2.071.935 3.333.935zm-12.167-3.833c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5zm3.236-1.14l-.09.411c-.192-.067-.405-.128-.611-.116-.372.022-.405.344-.145.479.428.201.985.35.985.886.001.429-.334.659-.749.716v.264h-.251v-.25c-.259-.004-.526-.066-.749-.181l.113-.411c.239.092.558.191.807.135.287-.065.346-.36.028-.503-.233-.108-.944-.201-.944-.811 0-.341.261-.646.746-.713v-.266h.251v.254c.179.005.382.037.609.106zm6.264-5.36h-17v10h-1v-11h18v1zm2 1v2.834c-.715.059-1.401.214-2 .458v-1.292h-14v7h12v2h-14v-11h18z"/></svg>
                             Multi warehouses payments generated
                          </h2>
                          <div  class="flex items-center sm:ml-auto mt-3 sm:mt-0">
                             <svg @click="refresh"  xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" :class="loading?'noselect':''" class="mr-3 cursor-pointer"><path  d="M20.944 12.979c-.489 4.509-4.306 8.021-8.944 8.021-2.698 0-5.112-1.194-6.763-3.075l1.245-1.633c1.283 1.645 3.276 2.708 5.518 2.708 3.526 0 6.444-2.624 6.923-6.021h-2.923l4-5.25 4 5.25h-3.056zm-15.864-1.979c.487-3.387 3.4-6 6.92-6 2.237 0 4.228 1.059 5.51 2.698l1.244-1.632c-1.65-1.876-4.061-3.066-6.754-3.066-4.632 0-8.443 3.501-8.941 8h-3.059l4 5.25 4-5.25h-2.92z"></path></svg>
                             <button @click="downloadCsv"  class="btnn box flex items-center bg-blue-500 text-gray-100 cursor-pointer loidingconfirm relative" :class="loading?'noselect':''"><svg  xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-text hidden sm:block w-4 h-4 mr-2 hidden sm:block w-4 h-4 mr-2"><path  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline  points="14 2 14 8 20 8"></polyline><line  x1="16" y1="13" x2="8" y2="13"></line><line  x1="16" y1="17" x2="8" y2="17"></line><polyline  points="10 9 9 9 8 9"></polyline></svg> <loading :active.sync="loading" :is-full-page="fullPage"></loading> Export to Csv </button>
                          </div>
                        </div>
                        <div class="mt-6" style="overflow-x: auto;">
                                <table id="payment-tab" class="responsive-table relative">
                                      <thead class="ant-table-thead">
                                        <tr>
                                            <th :rowspan="ordersByseller.length>0?3:''">Seller</th>
                                            <th :colspan="ordersByseller.length>0?ordersByseller[0][1].length*2+1:''">Warehouses</th>
                                            <th :rowspan="ordersByseller.length>0?3:''">Payment method</th>
                                            <th style="position: sticky; right: 0px;" class="ant-table-cell-fix-right-first ant-table-cell-fix-right" :rowspan="ordersByseller.length>0?3:''">Action</th>
                                        </tr>
                                        <tr v-if="ordersByseller.length>0" class="warehouses intro-x">
                                          <th v-for="(item, index) in ordersByseller[0][1]" :key="'header-'+index" :colspan="item.name=='Total pending'?3:2"><img v-if="item.flag" :src="item.flag" class="w-4 inline-block h-4 rounded-full mr-2"> {{item.name}} <sup v-if="item.currency">({{item.currency}})</sup></th>
                                        </tr>
                                        <tr v-if="ordersByseller.length>0" class="orders intro-x">
                                          <template v-for="(item1) in ordersByseller[0][1]"> 
                                            <th>Orders</th>
                                            <th>Amount</th>
                                            <th v-if="item1.name=='Total pending'">Mad</th>
                                          </template>
                                        </tr>
                                      </thead> 
                                       <tbody  v-if="ordersByseller.length==0" class="relative">
                                          <tr class="intro-x empty-tab">
                                            <td colspan="4" class="text-center-imp padding-empty">
                                                <span v-if="loading"> Loading Data ... <img class="img-paym" :src="spinner" /></span>
                                                <span v-else> No Data Found </span>   
                                            </td>
                                          </tr>
                                      </tbody> 
                                      <tbody  v-if="ordersByseller.length>0" class="relative">
                                        <tr v-for="(ele, index) in ordersByseller" :key="'seller-'+index" class="intro-x" v-if="ele[2].display">
                                          <td width="250" scope="row" class="text-left-imp font-bold text-gray-700 fz-14">
                                              <div v-if="!ele[2].userData" class="spinner-g">
                                                  <div class="spinner-1"></div>
                                                  <div class="spinner-2"></div>
                                                  <div class="spinner-3"></div>
                                              </div>
                                              <div v-else><moukhtar-avatar inline :username="ele[2].userData"  :size="30"></moukhtar-avatar> {{ele[2].userData }}</div>
                                          </td>
                                          <template v-for="(item2) in ele[1]" > 
                                              <td :style="randomHexColor(item2.index)" :class="item2.count?'':'empty-row'">{{item2.count?item2.count:''}}</td>
                                              <td :style="randomHexColor(item2.index)" :class="item2.sum?'':'empty-row'">
                                                 <span v-if="item2.sumSameCurrency && item2.sumSameCurrency.length>1">
                                                    <table class="responsive-table relative">
                                                       <thead>
                                                          <tr>
                                                              <th v-for="(item3, index) in item2.sumSameCurrency" :key="'tabs-'+index" style="font-size: 10px;padding: 1px;">{{item3.currency}}</th>
                                                          </tr>   
                                                       </thead>
                                                       <tbody>  
                                                          <tr>
                                                              <td  v-for="(item4, index) in item2.sumSameCurrency" :key="'tabh-'+index" style="padding: 1px;font-size: 13px;background: white;">{{item4.sum.toFixed()}}</td>
                                                          </tr>    
                                                       </tbody>
                                                    </table> 
                                                 </span>
                                                 <span v-else>{{item2.sum?item2.sum.toFixed():''}}</span>
                                              </td>
                                              <td v-if="item2.name=='Total pending'" :style="randomHexColor(item2.index)" :class="item2.mad?'':'empty-row'">{{item2.mad?item2.mad.toFixed():''}}</td>
                                           </template>
                                          <td>
                                              <select id="type" name="method" autocomplete="type" v-model="ele[2].method" class="py-1 text-center capitalize  outline-none block h-full w-full bg-white">
                                                <option
                                                  v-for="(method,i) in options"
                                                  :key="i"
                                                  :value="method">
                                                  {{ method }}
                                                </option>
                                              </select>
                                          </td>
                                          <td style="position: sticky; right: 0px;" class="ant-table-cell-fix-right ant-table-cell-fix-right-first"><button @click="OpenClosePopPayMethode('open','Modalprocessaid',ele)" :class="!ele[2].userData||paymentsInfo.loading?'noselect':''" class="btnn px-5-im box flex items-center bg-orange-500 text-white cursor-pointer loidingconfirm relative"> <loading v-if="paymentsInfo.sellerSelect.id && (paymentsInfo.sellerSelect.id === ele[0])" :active.sync="paymentsInfo.loading" :is-full-page="fullPage"></loading> <svg class="fill-current mr-3" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M24 19h-1v-2.2c-1.853 4.237-6.083 7.2-11 7.2-6.623 0-12-5.377-12-12h1c0 6.071 4.929 11 11 11 4.66 0 8.647-2.904 10.249-7h-2.249v-1h4v4zm-11.036 0h-1.886c-.34-.957-.437-1.571-1.177-1.878h-.001c-.743-.308-1.251.061-2.162.494l-1.333-1.333c.427-.899.804-1.415.494-2.163-.308-.74-.926-.839-1.878-1.177v-1.886c.954-.339 1.57-.437 1.878-1.178.308-.743-.06-1.248-.494-2.162l1.333-1.333c.918.436 1.421.801 2.162.494l.001-.001c.74-.307.838-.924 1.177-1.877h1.886c.34.958.437 1.57 1.177 1.877l.001.001c.743.308 1.252-.062 2.162-.494l1.333 1.333c-.435.917-.801 1.421-.494 2.161v.001c.307.739.915.835 1.878 1.178v1.886c-.953.338-1.571.437-1.878 1.178-.308.743.06 1.249.494 2.162l-1.333 1.333c-.92-.438-1.42-.802-2.157-.496-.746.31-.844.926-1.183 1.88zm-.943-4.667c-1.289 0-2.333-1.044-2.333-2.333 0-1.289 1.044-2.334 2.333-2.334 1.289 0 2.333 1.045 2.333 2.334 0 1.289-1.044 2.333-2.333 2.333zm-8.021-5.333h-4v-4h1v2.2c1.853-4.237 6.083-7.2 11-7.2 6.623 0 12 5.377 12 12h-1c0-6.071-4.929-11-11-11-4.66 0-8.647 2.904-10.249 7h2.249v1z"/></svg> Processed </button></td>
                                        </tr>
                                      </tbody> 
                                     <tbody>
                                       <tr class="intro-x" style="background: linear-gradient(135deg, #4e97d5 25%, transparent 25%) -50px 0, linear-gradient(225deg, #4e97d5 25%, transparent 25%) -50px 0, linear-gradient(315deg, #4e97d5 25%, transparent 25%), linear-gradient(45deg, #4e97d5 25%, transparent 25%);background-size: 70px 86px;background-color: #2882cc;color: #fff;" v-if="paymentsInfoTotal.data.length>0">
                                          <td scope="row" class="text-left-imp font-bold text-gray-700 fz-14" style="color: white;">Total :</td>
                                          <template v-for="(item) in paymentsInfoTotal.data" >
                                              <td>{{item.count}}</td>
                                              <td>
                                                 <span v-if="item.sumSameCurrency && item.sumSameCurrency.length>1">
                                                    <table class="responsive-table relative">
                                                       <thead>
                                                          <tr>
                                                              <th v-for="(item3, index) in item.sumSameCurrency" :key="'tabs-'+index" style="font-size: 10px;padding: 1px;background: white;background-color: black">{{item3.currency}}</th>
                                                          </tr>   
                                                       </thead>
                                                       <tbody>  
                                                          <tr>
                                                              <td  v-for="(item4, index) in item.sumSameCurrency" :key="'tabh-'+index" style="padding: 1px;font-size: 13px;background: white;color: black">{{item4.sum.toFixed()}}</td>
                                                          </tr>    
                                                       </tbody>
                                                    </table> 
                                                 </span>
                                                 <span v-else>{{item.sum.toFixed()}}</span>
                                              </td>
                                           </template>
                                           <td colspan="3"></td>
                                        </tr> 
                                     </tbody>
                                </table>
                                <!-- <table v-else class="responsive-table">
                                  <thead><tr><th>Seller</th><th>Warehouses</th><th>Payment method</th><th>Action</th></tr></thead>
                                  <tbody class="relative">
                                     <tr class="intro-x empty-tab">
                                        <td colspan="4" class="text-center-imp padding-empty">
                                             <span v-if="loading"> Loading Data ... <img class="img-paym" :src="spinner" /></span>
                                             <span v-else> No Data Found </span>   
                                        </td>
                                      </tr>
                                  </tbody>
                                </table> -->
                                <!-- <loading :active.sync="loadingorderbyseller" :is-full-page="fullPage"></loading>
                                <tableTotalAmountMulti v-for="(totalorders,index) in ordersByseller" :key="index" :warehouse="idWharhouse" :sellerSelect="sellerSelect" :loadingShowPay="loadingShowPay" :item="totalorders"   @OpenClosePopPayMethode="OpenClosePopPayMethode"/>   
                            </table> -->

                            <dialog class="printingExcel">
                                <modal-export-excel-payments type="PaymentsByseller" :dataItems="paymentsInfoTotal.data"  :items="ordersByseller" />
                            </dialog>   

                             <vue-modal-2 name="Modalprocessaid" :headerOptions="{title: 'Payement processaid'}"  :noFooter="true" modalSize="lg" @on-close="OpenClosePopPayMethode('close','Modalprocessaid')">
                                <loading :active.sync="paymentsInfo.loading" :is-full-page="fullPage"></loading>
                                <div class="bg-white rounded-lg">
                                    <div class="w-96 rounded-lg mb-20 flex">
                                    <div class="w-1/3 pt-6 flex justify-center items-center">
                                        <span class="w-16 h-16 bg-blue-600  text-white p-3 rounded-full"><i class="material-icons" style="font-size: 40px;">payment</i></span>
                                    </div>
                                    <div class="w-full pr-4">
                                        <h3 class="font-bold text-blue-600 mb-5">Payement Infos</h3>
                                        <div  class="flex items-center">
                                           <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4 mb-2">
                                                <span  class="font-bold">Seller </span>
                                                <div  class="text-gray-600 font-medium">{{paymentsInfo.sellerSelect.name}}</div>
                                                <hr> 
                                                 <span  class="font-bold">Warehouses </span>
                                                <div  class="text-gray-600 flex py-1">
                                                    <span v-for="(images, r) in paymentsInfo.dataWarehouses" :key="r">
                                                         <img :src="images.flag" class="w-4 h-4 rounded-full mr-2">
                                                    </span>
                                                </div>
                                                <hr>
                                                <span  class="font-bold">Amount total ({{paymentsInfo.count}} orders)</span>
                                                <div class="text-gray-600 font-medium">
                                                  <span class="flex" v-if="paymentsInfo.amountSameCurrency.length > 0">
                                                      <div class="tab-amount pr-2" v-for="(item3, index) in paymentsInfo.amountSameCurrency" :key="'tabs-'+index">
                                                           {{item3.sum.toFixed()}} <sup>{{item3.currency}}</sup> <span v-if="paymentsInfo.amountSameCurrency.length-1 != index">|</span>
                                                      </div>
                                                  </span>
                                                  <span v-else>{{paymentsInfo.amount.toFixed()}}</span>  
                                                </div>
                                           </div>
                                        </div>
                                    </div>
                                    </div>

                                    <div class="p-4 flex space-x-4 modal-footer">
                                    <a href="#" @click="OpenClosePopPayMethode('close','Modalprocessaid')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                                    <a href="#"  @click="confirmData" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600  rounded-lg hover:bg-blue-700  hover:text-white font-bold text-sm">Confirm</a>
                                    </div>
                                </div> 
                            </vue-modal-2> 
                        </div>
                        <!--/payments by seller-->    
                </div>
            </div>
        </div>
    </div>
   </div>
</template>

<script>
import tableTotalAmountMulti from '@/views/payments/tableTotalAmountMulti.vue'
import spinner from "@/assets/spinner.gif";
import Cookies from 'js-cookie'
export default {
   components: {
      tableTotalAmountMulti
    },
    props: {
      currentUser: { type: Object},
      idWharhouse: { type: Object}
   },
  data() {
    return {
      loading: false,
      fullPage: false,
      loadingShowPay:0,
      ordersByseller: [],
      paymentsInfo:{ status:"processed",dataWarehouses:[],amountSameCurrency:[],amount:0,count:0, sellerSelect:{name:null,id:null},loading:false },
      paymentsInfoTotal:{name:'Total :',data:[]},
      totalOrders : [],
      loadingShowPay:false,
      totalAmount:0,
      spinner:spinner,
      totalOrderscount:0,
      options:["transfer","paypal","cash"]
    };
  },
  async mounted() {
     await this.getPayement({});
  },
  watch: { 
        'warhouseSelected': async function(oldVal, newVal) {
            // await this.getwharhouseId();
            // await this.refresh();
        },
        'idWharhouse': async function(oldVal, newVal) {
            this.idWharhouse=oldVal;  
            await this.refresh();
        }
   },
   computed: {
        warhouseSelected(){
            return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
        },
  }, 
  methods: {
    async getUser() {
         const res = await this.$me;
         this.currentUser = res.content;
    },
    randomHexColor(index) {
        const colors=["#ba96ce", "#679c9d", "#c6c42c", "#48b41b", "#5be4f0", "#57c4d8", "#a4d17a", "#225b8", "#be608b", "#96b00c", "#088baf", "#f158bf", "#e145ba", "#ee91e3", "#05d371", "#5426e0", "#4834d0", "#802234", "#6749e8", "#0971f0", "#8fb413", "#b2b4f0", "#c3c89d", "#c9a941", "#41d158", "#fb21a3", "#51aed9", "#5bb32d", "#807fb", "#21538e", "#89d534", "#d36647", "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3", "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", ];
        return 'background: ' + colors[index];        
    },
    async getwharhouseId(){
         await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    },
    async getSellers() {
      if (this.currentUser && this.currentUser.type && this.currentUser.type != "Seller") {
          const res = await this.$server.search("users", {type: "Seller",limit:10});
          if (res.content.results) this.sellers = res.content.results;
          else this.sellers = [];
      }
    },
    async refresh() {
        this.emptyData();
        await this.getPayement({});
    }, 
    emptyData() {
       this.ordersByseller=[];this.paymentsInfoTotal.data=[]
       this.paymentsInfo.amount=0;this.paymentsInfo.count=0; this.paymentsInfo.amountSameCurrency=[];
       this.paymentsInfo.sellerSelect={name:null,id:null};this.paymentsInfo.loading=false;
    },
    getTotalData(){
      this.paymentsInfoTotal.data=[]
      this.ordersByseller.forEach(e => { 
              e[1].forEach(e2 => {
                //console.log('e2--------',e[2])
                 let dataO={name:e2.name,sum:e2.sum,count:e2.count,index:e2.index,sumSameCurrency:[]};
                  if(e2.sumSameCurrency && e2.sumSameCurrency.length > 1) dataO.sumSameCurrency=e2.sumSameCurrency;
                 if(e[2].display) this.paymentsInfoTotal.data.push(dataO); 
              });
             // seller[1].reduce((n, {count}) => n + count, 0)
             //records.filter(({gender}) => gender === 'BOYS').reduce((sum, record) => sum + record.value)
            });
            console.log('payment data-----', this.ordersByseller)
            
            var resultRemoveduplicated = this.paymentsInfoTotal.data.reduce((a,c) => {
                a[c.name] = a[c.name] || {name: c.name,index: c.index, sum: 0, count: 0,sumSameCurrency:c.sumSameCurrency};
                a[c.name].sum += c.sum;
                a[c.name].count += c.count;
                // console.log('a[c.name].sumSameCurrency------',a[c.name].sumSameCurrency)
                //  console.log('c.sumSameCurrency------',c.sumSameCurrency)
                if(c.sumSameCurrency && c.sumSameCurrency.length>1) {
                  a[c.name].sumSameCurrency=a[c.name].sumSameCurrency.concat(c.sumSameCurrency)
                 // c.sumSameCurrency.forEach((bb, i) => { if(i!=0) a[c.name].sumSameCurrency.push(bb)})
                }  
                return a;
              }, {})
               console.log('resultRemoveduplicated-----', resultRemoveduplicated)
              if(resultRemoveduplicated['Total pending'] && resultRemoveduplicated['Total pending'].sumSameCurrency.length>1) {
                    let newArray = []
                    for (const entry of resultRemoveduplicated['Total pending'].sumSameCurrency) {
                      if (!this.isDuplicate(entry, newArray)) { newArray.push(entry) }
                    }
                    resultRemoveduplicated['Total pending'].sumSameCurrency=newArray;
                    resultRemoveduplicated['Total pending'].sumSameCurrency.sort((a, b) => a.index < b.index ? -1 : (a.index > b.index ? 1 : 0))
                    resultRemoveduplicated['Total pending'].sumSameCurrency=Object.values(resultRemoveduplicated['Total pending'].sumSameCurrency.reduce((a,c) => {
                        a[c.currency] = a[c.currency] || {currency: c.currency,index: c.index,sum: 0, count: 0};
                        a[c.currency].sum += c.sum;
                        a[c.currency].count += c.count;
                        return a;
                    }, {}))
                }
           console.log('result-----', resultRemoveduplicated)
            this.paymentsInfoTotal.data=Object.values(resultRemoveduplicated);  
    },
    async getPayement(filters) {
        this.loading = true;
        filters.warehouse=this.idWharhouse._id;
        this.ordersByseller=[];
        const res = await this.$server.getPaymentsByseller("payments",filters);
        this.loading=false;
        if(res && res.data) {
            console.table(res.data)
            this.ordersByseller=res.data;
            this.paymentsInfo.dataWarehouses=res.warehouses;
            this.getTotalData();
            await this.gateDatausersByType();
            
        }else this.emptyData();
        // this.totalAmount=0;
        // this.totalOrderscount=0;
        // this.ordersByseller.forEach(e => { this.totalAmount += e.amount;this.totalOrderscount += e.count;});
        
    },
    isDuplicate(entry, arr) {
      return arr.some(x => (entry.index == x.index) && (entry.sum == x.sum) && (entry.count == x.count) && (entry.currency == x.currency))
    },
    async OpenClosePopPayMethode(action,name,data=null){
         console.log('action-------------',action)
         console.log('data-------------',data)
         this.paymentsInfo.loading=true;
         if(action=='open'){
            if(data){
                this.paymentsInfo.sellerSelect.name=data[2].userData;
                this.paymentsInfo.sellerSelect.id=data[0];
                var item = data[1].find(item => item.name === "Total pending");
                this.paymentsInfo.amount=item.sum; this.paymentsInfo.count=item.count;
                if(item.sumSameCurrency && item.sumSameCurrency.length>1) this.paymentsInfo.amountSameCurrency=item.sumSameCurrency;
                this.$vm2.open(name);  
             }else {alert("Seller Or data not defined !");this.refresh()};   
         }else {
          this.$vm2.close(name);
          if(name == 'Modalprocessaid'){
            this.paymentsInfo.amount=0;this.paymentsInfo.count=0; this.paymentsInfo.amountSameCurrency=[];
            this.paymentsInfo.sellerSelect={name:null,id:null};this.paymentsInfo.loading=false;
          }
        };  
        this.paymentsInfo.loading=false;   
    },
    async confirmData(){
     
      console.log(' this.paymentsInfo-----', this.paymentsInfo)
      console.log(' orders -----', this.ordersByseller)
   
     
         this.paymentsInfo.loading=true;
         const res = await this.$server.updateMany("payments",this.paymentsInfo);
         this.paymentsInfo.loading=false;
         if((res && res.length==0) || (res && res.ok)) {
              alert("Payments updated", "success");
              this.$vm2.close("Modalprocessaid");
              this.ordersByseller.forEach(e => { 
                if(e[0].toString() == this.paymentsInfo.sellerSelect.id.toString()) e[2].display=false;
              });
              this.getTotalData();
             // await this.refresh({});
         }else alert(res.content||res, "warning");  
    },
    downloadCsv: function () {
          //this.dataExcel=[];
        if(this.ordersByseller.length>0) {
                var nameTable="Multi_payments";
                var htmls = "";
                var uri = 'data:application/vnd.ms-excel;base64,';
                var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'; 
                var base64 = function(s) {
                    return window.btoa(unescape(encodeURIComponent(s)))
                };

                var format = function(s, c) {
                    return s.replace(/{(\w+)}/g, function(m, p) {
                        return c[p];
                    })
                };
                const table =document.getElementById("p-table");
                htmls =table.outerHTML
                var ctx = {
                    worksheet : nameTable,
                    table : htmls
                }

                var link = document.createElement("a");
                link.download = nameTable+".xls";
                link.href = uri + base64(format(template, ctx));
                link.click();
        };
    },
    async getUserById(id){
        const editData = await this.$server.get("users", {id: id});
        return editData.content;
    },
    DataParse(data){
        if (typeof data !== 'undefined') {
          return JSON.parse(data);
        }
        return ''; 
    },
    async gateDatausersByType(){
          for (let i in this.ordersByseller) {
           // if(!Cookies.get(this.ordersByseller[i][0].toString())){
             // let userData={fullName:"System"};
              const getUser=await this.getUserById(this.ordersByseller[i][0]);
              console.log('getUser---------',getUser)
             // userData={fullName:getUser.fullName||getUser.email}
              this.ordersByseller[i][2].userData= getUser.fullName||getUser.email;
              if(getUser.rib) this.ordersByseller[i][2].userDataRib= getUser.rib.toString();
             // Cookies.set(this.ordersByseller[i][0].toString(), JSON.stringify(userData), { expires: 20 })
             // Cookies.remove(this.ordersByseller[i][0].toString()); // fail!
           // }else {this.ordersByseller[i][2].userData=Cookies.get(this.ordersByseller[i][0]);  }
          }
       //console.log('Cokies item --------',Cookies.get()) //get all cockies
    },

  },
};
</script>

<style scoped>
table>thead>tr:first-child th:last-child {
    border-top-right-radius: 4px;
}
.ant-table-cell-fix-right {
    position: -webkit-sticky!important;
    position: sticky!important;
    z-index: 2;
    background: #fff;
}
.ant-table-thead > tr > th{
 background: rgb(203 213 224);
}
.ant-table-cell-fix-right-first:after, .ant-table-cell-fix-right-last:after {
    position: absolute;
    top: 0;
    bottom: -1px;
    left: 0;
    width: 30px;
    transform: translateX(-100%);
    transition: box-shadow .3s;
    content: "";
    pointer-events: none;
    box-shadow: inset -10px 0 8px -8px rgb(0 0 0 / 15%);
}
.empty-row{
  /* background: repeating-linear-gradient(53deg,#bfc0c2 4%,#fcfcff 11px 6%,#fff 0 7%,#9d9c9c 15px) !important; */
  background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important;
}
.text-left-imp{
  text-align:left !important;
}
.fz-14{
  font-size:14px;
}
hr {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1px;
}
table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
}
.px-5-im{
    padding-top: 5px !important;
    padding-bottom: 5px !important;
}
.empty-tab{
  height: 200px;
}
.text-center-imp{
  text-align: center !important;
}

.form-payement{
  min-height: 40rem
}
th, td {
    padding: 5px;
    text-align: center;    
}
.responsive-table {
  width: 100%;
  border-collapse: separate;
  text-indent: initial;
  border-spacing: 2px;
} 

.warehouses th{
    background-color: #efeff0 !important;
    color: #090909 !important;
}
.warehouses th:last-child{
    background-color: #212122 !important;
    color: #fff !important;
}
.orders th{
  background-color: #cacaca !important;
  color: #353533 !important;
}
.responsive-table thead {
    position: relative;
    clip: auto;
    height: auto;
    width: auto;
    overflow: auto;
}
.responsive-table thead th {
    background-color: #4299e1;
    border: 1px solid #4e504a;
    font-weight: 500;   
    color: #faf4f4;
}
.responsive-table thead th:first-of-type {
  text-align: center;
}
.responsive-table tr {
  display: table-row;
}
.responsive-table th,
.responsive-table td {
  padding: 3px;
  vertical-align: middle;
  display: table-cell;
}
.spinner-g .spinner-1 {
    animation: fade 1.1s ease-in-out 0.18s infinite both;
}
.spinner-g .spinner-2 {
    animation: fade 1.1s ease-in-out 0.36s infinite both;
}
.spinner-g .spinner-3 {
    animation: fade 1.1s ease-in-out 0.54s infinite both;
}
.spinner-g * {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    background-color: #4299e1;
    border-radius: 1rem;
    margin: 0 0.2rem;
}
@keyframes fade {
  0% {
      opacity: 0.35;
      transform: scale(0.87);
  }
  37.5% {
      opacity: 1;
      transform: scale(1);
  }
  75% {
      opacity: 0.35;
      transform: scale(0.87);
  }
  100% {
      opacity: 0.35;
      transform: scale(0.87);
  }
}

*>.intro-x:first-child {
 transform:translateX(50px)
}
*>.-intro-x:first-child,
*>.intro-x:first-child {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.1s;
 animation-delay:.1s
}
*>.-intro-x:first-child {
 transform:translateX(-50px)
}
*>.intro-y:first-child {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.1s;
 animation-delay:.1s
}
*>.intro-x:nth-child(2) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(2),
*>.intro-x:nth-child(2) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.2s;
 animation-delay:.2s
}
*>.-intro-x:nth-child(2) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(2) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.2s;
 animation-delay:.2s
}
*>.intro-x:nth-child(3) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(3),
*>.intro-x:nth-child(3) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.3s;
 animation-delay:.3s
}
*>.-intro-x:nth-child(3) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(3) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.3s;
 animation-delay:.3s
}
*>.intro-x:nth-child(4) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(4),
*>.intro-x:nth-child(4) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.4s;
 animation-delay:.4s
}
*>.-intro-x:nth-child(4) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(4) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.4s;
 animation-delay:.4s
}
*>.intro-x:nth-child(5) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(5),
*>.intro-x:nth-child(5) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.5s;
 animation-delay:.5s
}
*>.-intro-x:nth-child(5) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(5) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.5s;
 animation-delay:.5s
}
*>.intro-x:nth-child(6) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(6),
*>.intro-x:nth-child(6) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.6s;
 animation-delay:.6s
}
*>.-intro-x:nth-child(6) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(6) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.6s;
 animation-delay:.6s
}
*>.intro-x:nth-child(7) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(7),
*>.intro-x:nth-child(7) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.7s;
 animation-delay:.7s
}
*>.-intro-x:nth-child(7) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(7) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.7s;
 animation-delay:.7s
}
*>.intro-x:nth-child(8) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(8),
*>.intro-x:nth-child(8) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.8s;
 animation-delay:.8s
}
*>.-intro-x:nth-child(8) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(8) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.8s;
 animation-delay:.8s
}
*>.intro-x:nth-child(9) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(9),
*>.intro-x:nth-child(9) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.9s;
 animation-delay:.9s
}
*>.-intro-x:nth-child(9) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(9) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.9s;
 animation-delay:.9s
}
*>.intro-x:nth-child(10) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(10),
*>.intro-x:nth-child(10) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1s;
 animation-delay:1s
}
*>.-intro-x:nth-child(10) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(10) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1s;
 animation-delay:1s
}
*>.intro-x:nth-child(11) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(11),
*>.intro-x:nth-child(11) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.1s;
 animation-delay:1.1s
}
*>.-intro-x:nth-child(11) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(11) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.1s;
 animation-delay:1.1s
}
*>.intro-x:nth-child(12) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(12),
*>.intro-x:nth-child(12) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.2s;
 animation-delay:1.2s
}
*>.-intro-x:nth-child(12) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(12) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.2s;
 animation-delay:1.2s
}
*>.intro-x:nth-child(13) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(13),
*>.intro-x:nth-child(13) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.3s;
 animation-delay:1.3s
}
*>.-intro-x:nth-child(13) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(13) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.3s;
 animation-delay:1.3s
}
*>.intro-x:nth-child(14) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(14),
*>.intro-x:nth-child(14) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.4s;
 animation-delay:1.4s
}
*>.-intro-x:nth-child(14) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(14) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.4s;
 animation-delay:1.4s
}
*>.intro-x:nth-child(15) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(15),
*>.intro-x:nth-child(15) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.5s;
 animation-delay:1.5s
}
*>.-intro-x:nth-child(15) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(15) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.5s;
 animation-delay:1.5s
}
*>.intro-x:nth-child(16) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(16),
*>.intro-x:nth-child(16) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.6s;
 animation-delay:1.6s
}
*>.-intro-x:nth-child(16) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(16) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.6s;
 animation-delay:1.6s
}
*>.intro-x:nth-child(17) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(17),
*>.intro-x:nth-child(17) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.7s;
 animation-delay:1.7s
}
*>.-intro-x:nth-child(17) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(17) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.7s;
 animation-delay:1.7s
}
*>.intro-x:nth-child(18) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(18),
*>.intro-x:nth-child(18) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.8s;
 animation-delay:1.8s
}
*>.-intro-x:nth-child(18) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(18) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.8s;
 animation-delay:1.8s
}
*>.intro-x:nth-child(19) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(19),
*>.intro-x:nth-child(19) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.9s;
 animation-delay:1.9s
}
*>.-intro-x:nth-child(19) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(19) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.9s;
 animation-delay:1.9s
}
*>.intro-x:nth-child(20) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(20),
*>.intro-x:nth-child(20) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2s;
 animation-delay:2s
}
*>.-intro-x:nth-child(20) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(20) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2s;
 animation-delay:2s
}
*>.intro-x:nth-child(21) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(21),
*>.intro-x:nth-child(21) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.1s;
 animation-delay:2.1s
}
*>.-intro-x:nth-child(21) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(21) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.1s;
 animation-delay:2.1s
}
*>.intro-x:nth-child(22) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(22),
*>.intro-x:nth-child(22) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.2s;
 animation-delay:2.2s
}
*>.-intro-x:nth-child(22) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(22) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.2s;
 animation-delay:2.2s
}
*>.intro-x:nth-child(23) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(23),
*>.intro-x:nth-child(23) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.3s;
 animation-delay:2.3s
}
*>.-intro-x:nth-child(23) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(23) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.3s;
 animation-delay:2.3s
}
*>.intro-x:nth-child(24) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(24),
*>.intro-x:nth-child(24) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.4s;
 animation-delay:2.4s
}
*>.-intro-x:nth-child(24) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(24) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.4s;
 animation-delay:2.4s
}
*>.intro-x:nth-child(25) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(25),
*>.intro-x:nth-child(25) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.5s;
 animation-delay:2.5s
}
*>.-intro-x:nth-child(25) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(25) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.5s;
 animation-delay:2.5s
}
*>.intro-x:nth-child(26) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(26),
*>.intro-x:nth-child(26) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.6s;
 animation-delay:2.6s
}
*>.-intro-x:nth-child(26) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(26) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.6s;
 animation-delay:2.6s
}
*>.intro-x:nth-child(27) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(27),
*>.intro-x:nth-child(27) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.7s;
 animation-delay:2.7s
}
*>.-intro-x:nth-child(27) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(27) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.7s;
 animation-delay:2.7s
}
*>.intro-x:nth-child(28) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(28),
*>.intro-x:nth-child(28) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.8s;
 animation-delay:2.8s
}
*>.-intro-x:nth-child(28) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(28) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.8s;
 animation-delay:2.8s
}
*>.intro-x:nth-child(29) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(29),
*>.intro-x:nth-child(29) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.9s;
 animation-delay:2.9s
}
*>.-intro-x:nth-child(29) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(29) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.9s;
 animation-delay:2.9s
}
*>.intro-x:nth-child(30) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(30),
*>.intro-x:nth-child(30) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3s;
 animation-delay:3s
}
*>.-intro-x:nth-child(30) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(30) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3s;
 animation-delay:3s
}
*>.intro-x:nth-child(31) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(31),
*>.intro-x:nth-child(31) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.1s;
 animation-delay:3.1s
}
*>.-intro-x:nth-child(31) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(31) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.1s;
 animation-delay:3.1s
}
*>.intro-x:nth-child(32) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(32),
*>.intro-x:nth-child(32) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.2s;
 animation-delay:3.2s
}
*>.-intro-x:nth-child(32) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(32) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.2s;
 animation-delay:3.2s
}
*>.intro-x:nth-child(33) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(33),
*>.intro-x:nth-child(33) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.3s;
 animation-delay:3.3s
}
*>.-intro-x:nth-child(33) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(33) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.3s;
 animation-delay:3.3s
}
*>.intro-x:nth-child(34) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(34),
*>.intro-x:nth-child(34) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.4s;
 animation-delay:3.4s
}
*>.-intro-x:nth-child(34) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(34) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.4s;
 animation-delay:3.4s
}
*>.intro-x:nth-child(35) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(35),
*>.intro-x:nth-child(35) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.5s;
 animation-delay:3.5s
}
*>.-intro-x:nth-child(35) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(35) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.5s;
 animation-delay:3.5s
}
*>.intro-x:nth-child(36) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(36),
*>.intro-x:nth-child(36) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.6s;
 animation-delay:3.6s
}
*>.-intro-x:nth-child(36) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(36) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.6s;
 animation-delay:3.6s
}
*>.intro-x:nth-child(37) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(37),
*>.intro-x:nth-child(37) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.7s;
 animation-delay:3.7s
}
*>.-intro-x:nth-child(37) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(37) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.7s;
 animation-delay:3.7s
}
*>.intro-x:nth-child(38) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(38),
*>.intro-x:nth-child(38) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.8s;
 animation-delay:3.8s
}
*>.-intro-x:nth-child(38) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(38) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.8s;
 animation-delay:3.8s
}
*>.intro-x:nth-child(39) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(39),
*>.intro-x:nth-child(39) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.9s;
 animation-delay:3.9s
}
*>.-intro-x:nth-child(39) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(39) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.9s;
 animation-delay:3.9s
}
*>.intro-x:nth-child(40) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(40),
*>.intro-x:nth-child(40) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4s;
 animation-delay:4s
}
*>.-intro-x:nth-child(40) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(40) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4s;
 animation-delay:4s
}
*>.intro-x:nth-child(41) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(41),
*>.intro-x:nth-child(41) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.1s;
 animation-delay:4.1s
}
*>.-intro-x:nth-child(41) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(41) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.1s;
 animation-delay:4.1s
}
*>.intro-x:nth-child(42) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(42),
*>.intro-x:nth-child(42) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.2s;
 animation-delay:4.2s
}
*>.-intro-x:nth-child(42) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(42) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.2s;
 animation-delay:4.2s
}
*>.intro-x:nth-child(43) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(43),
*>.intro-x:nth-child(43) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.3s;
 animation-delay:4.3s
}
*>.-intro-x:nth-child(43) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(43) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.3s;
 animation-delay:4.3s
}
*>.intro-x:nth-child(44) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(44),
*>.intro-x:nth-child(44) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.4s;
 animation-delay:4.4s
}
*>.-intro-x:nth-child(44) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(44) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.4s;
 animation-delay:4.4s
}
*>.intro-x:nth-child(45) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(45),
*>.intro-x:nth-child(45) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.5s;
 animation-delay:4.5s
}
*>.-intro-x:nth-child(45) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(45) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.5s;
 animation-delay:4.5s
}
*>.intro-x:nth-child(46) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(46),
*>.intro-x:nth-child(46) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.6s;
 animation-delay:4.6s
}
*>.-intro-x:nth-child(46) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(46) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.6s;
 animation-delay:4.6s
}
*>.intro-x:nth-child(47) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(47),
*>.intro-x:nth-child(47) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.7s;
 animation-delay:4.7s
}
*>.-intro-x:nth-child(47) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(47) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.7s;
 animation-delay:4.7s
}
*>.intro-x:nth-child(48) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(48),
*>.intro-x:nth-child(48) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.8s;
 animation-delay:4.8s
}
*>.-intro-x:nth-child(48) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(48) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.8s;
 animation-delay:4.8s
}
*>.intro-x:nth-child(49) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(49),
*>.intro-x:nth-child(49) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.9s;
 animation-delay:4.9s
}
*>.-intro-x:nth-child(49) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(49) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.9s;
 animation-delay:4.9s
}
*>.intro-x:nth-child(50) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(50),
*>.intro-x:nth-child(50) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:5s;
 animation-delay:5s
}
*>.-intro-x:nth-child(50) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(50) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:5s;
 animation-delay:5s
}
@-webkit-keyframes intro-x-animation {
 to {
  opacity:1;
  transform:translateX(0)
 }
}
@keyframes intro-x-animation {
 to {
  opacity:1;
  transform:translateX(0)
 }
}
@-webkit-keyframes intro-y-animation {
 to {
  opacity:1;
  transform:translateY(0)
 }
}
@keyframes intro-y-animation {
 to {
  opacity:1;
  transform:translateY(0)
 }
}
</style>